(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5186],{

/***/ 37304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ getAgents; }
});

// UNUSED EXPORTS: getAgent

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/agent.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AgentStatic;

(function (AgentStatic) {
  AgentStatic["AgenciesList"] = "/v2/agents";
})(AgentStatic || (AgentStatic = {}));

var AgentDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description get Agent details
   */
  AgentDetail: function AgentDetail(AgentID) {
    return "/v2/agents/".concat(AgentID);
  }
};
var agent_endpoint_AgentEndpoints = _objectSpread(_objectSpread({}, AgentDynamic), AgentStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/agent.request.ts


var getAgents = function getAgents(filters) {
  return (0,base_services_request/* getRequest */.A_)(agent_endpoint_AgentEndpoints.AgenciesList, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
var getAgent = function getAgent(id) {
  return getRequest(AgentEndpoints.AgentDetail(id)).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  })["catch"](function (error) {
    return error.response;
  });
};

/***/ }),

/***/ 51860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
 // https://stackoverflow.com/questions/63406435/how-to-detect-window-size-in-next-js-ssr-using-react-hook

function useWindowSize() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    width: undefined,
    height: undefined
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return windowSize;
}

/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);

/***/ }),

/***/ 75340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ collection; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./shared/components/custom-carrusel/index.tsx
var custom_carrusel = __webpack_require__(20518);
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
// EXTERNAL MODULE: ./api/agent.request.ts + 1 modules
var agent_request = __webpack_require__(37304);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/agent-collection-card-light/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








function AgentCollectionCardLight(props) {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.certifiedAgents");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCard, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerCard, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerImg, null, (0,emotion_react_browser_esm/* jsx */.tZ)(UserImage, {
    src: props.picture,
    alt: props.name + "-" + props.id
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(LabelName, null, props.name), (0,emotion_react_browser_esm/* jsx */.tZ)(LabelSubtitle, null, translation("agentOf"), " ", props.agencia)), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_agent_detail */.K.es.collection_agent_detail({
      id: props.id,
      name: props.name
    }) + "?referer=" + props.id,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--bg-secondary"
  }, translation("seeAgent")))));
}

/* harmony default export */ var agent_collection_card_light = (AgentCollectionCardLight);

var ContentCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm6"
} : 0)( true ? {
  name: "1agncuk",
  styles: "width:80%;background:transparent;margin:0 auto;@media screen and (max-width: 500px){width:90%;margin:auto;}"
} : 0);

var ContainerCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm5"
} : 0)( true ? {
  name: "ba1hru",
  styles: "border-radius:13px;text-align:center;width:100%;min-height:220px"
} : 0);

var ContainerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm4"
} : 0)( true ? {
  name: "zl1inp",
  styles: "display:flex;justify-content:center"
} : 0);

var ContainerImg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1kbt2rm3"
} : 0)( true ? {
  name: "zov8s0",
  styles: "width:100%;display:flex;justify-content:center"
} : 0);

var LabelName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1kbt2rm2"
} : 0)( true ? {
  name: "fxejr6",
  styles: "font-family:var(--font-family);font-style:normal;font-weight:700;font-size:16px;line-height:22px;display:block;color:var(--text-black);margin-top:10px"
} : 0);

var LabelSubtitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1kbt2rm1"
} : 0)( true ? {
  name: "1o02eu",
  styles: "font-family:var(--font-family);font-style:normal;font-weight:700;font-size:13px;line-height:16px;display:block;color:var(--color-brand-grey-secondary);margin-top:5px"
} : 0);

var UserImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1kbt2rm0"
} : 0)( true ? {
  name: "1v0myr5",
  styles: "width:130px;height:130px;border-radius:100%;object-fit:contain"
} : 0);
;// CONCATENATED MODULE: ./shared/components/slider-collection-agents/index.tsx




function slider_collection_agents_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









function SliderCollectionAgents() {
  var _data$data;

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,agent_request/* getAgents */.j)({
                page: 1,
                collections: true
              });

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation = (0,useMutation/* useMutation */.D)(["agents-slider"], fetchProjectSlider),
      data = _useMutation.data,
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError,
      mutate = _useMutation.mutate;

  react.useEffect(function () {
    mutate({});
  }, []);

  if (data && (data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.length) > 0 && isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Sin Resultados"
    });
  }

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Ha ocurrido un error"
    });
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(custom_carrusel/* default */.Z, null, data === null || data === void 0 ? void 0 : data.data.map(function (item, i) {
    var _item$picture;

    return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, {
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(agent_collection_card_light, {
      picture: (_item$picture = item.picture) !== null && _item$picture !== void 0 ? _item$picture : "/icons/remax-logo-01.svg",
      name: item.name,
      agencia: item.agency_name,
      id: item.id
    }));
  }))));
}

/* harmony default export */ var slider_collection_agents = (SliderCollectionAgents);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1sp45kx1"
} : 0)( true ? {
  name: "87d5hs",
  styles: "display:flex;justify-content:center;padding:10px 5px"
} : 0);

var CollectionButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e1sp45kx0"
} : 0)( true ? {
  name: "132irba",
  styles: "width:100%;margin:auto;margin-top:20px;display:flex;justify-content:center"
} : 0);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./shared/components/a1-refactor/typography/WsSectionTitleWithThinTitle copy.tsx
var WsSectionTitleWithThinTitle_copy = __webpack_require__(71099);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/agents-collections.tsx



function agents_collections_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function AgentsCollections() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.certifiedAgents");
  var agentTitle = translation("title") || "";

  var _agentTitle$split = agentTitle.split(" "),
      _agentTitle$split2 = (0,toArray/* default */.Z)(_agentTitle$split),
      titleOne = _agentTitle$split2[0],
      titleTwo = _agentTitle$split2[1],
      rest = _agentTitle$split2.slice(2);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContentAgentsCollector, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    justifyContent: "center",
    mt: 4,
    mb: 5
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: rest.join(" "),
    subtitle: "".concat(titleOne, " ").concat(titleTwo),
    color: "--color-brand-blue-collection-main"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(slider_collection_agents, null), (0,emotion_react_browser_esm/* jsx */.tZ)(agents_collections_CollectionButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_agents_list */.K.es.collection_agents_list,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a",
    bg: "--color-brand-red-tertiary"
  }, translation("seeMore")))));
}

/* harmony default export */ var agents_collections = (AgentsCollections);

var agents_collections_CollectionButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e1xk6c231"
} : 0)( true ? {
  name: "qe273j",
  styles: "width:100%;margin:auto;margin-top:50px;display:flex;justify-content:center"
} : 0);

var ContentAgentsCollector = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xk6c230"
} : 0)( true ? {
  name: "np96ie",
  styles: "min-height:75vh;background:var(--color-brand-cream-primary);padding:70px 0px"
} : 0);
// EXTERNAL MODULE: ./shared/components/buy-sell-filter/index.tsx + 1 modules
var buy_sell_filter = __webpack_require__(97814);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/cover-section.tsx



function cover_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function CoverSection() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection");
  var welcomeTitle = translation("title") || "";

  var _welcomeTitle$split = welcomeTitle.split(" "),
      _welcomeTitle$split2 = (0,toArray/* default */.Z)(_welcomeTitle$split),
      titleOne = _welcomeTitle$split2[0],
      titleTwo = _welcomeTitle$split2[1],
      rest = _welcomeTitle$split2.slice(2);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Cover, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCover, null, (0,emotion_react_browser_esm/* jsx */.tZ)(TitlePrimary, null, titleOne, " ", titleTwo, " ", (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, rest.join(" "))), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentFilter, null, (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter/* default */.Z, {
    detailsRoute: pages_path/* CPagesPath.es.collection_property_detail */.K.es.collection_property_detail,
    collection: true
  }))));
}

/* harmony default export */ var cover_section = (CoverSection);

var ContentFilter = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fxybo74"
} : 0)( true ? {
  name: "fgx8rm",
  styles: "display:flex;width:auto;justify-content:center;align-items:center;padding-top:15vh;@media screen and (max-width: 500px){padding-top:10vh;}"
} : 0);

var ContentCover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fxybo73"
} : 0)( true ? {
  name: "4a98bl",
  styles: "width:80%;margin:auto;height:80vh"
} : 0);

var Cover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "e1fxybo72"
} : 0)( true ? {
  name: "n5woff",
  styles: "background:linear-gradient(\n      180deg,\n      #0000 0%,\n      #0000 78%,\n      var(--color-brand-blue-collection-main) 100%\n    ),url(\"/images/v2/pic/imagen-08.webp\");width:100%;height:100vh;background-position:center;background-size:cover;background-repeat:no-repeat;padding:110px 0;margin-top:-34px;@media screen and (max-width: 500px){padding:70px 0;}"
} : 0);

var CicleImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1fxybo71"
} : 0)( true ? {
  name: "y1f223",
  styles: "margin:auto"
} : 0);

var TitlePrimary = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1fxybo70"
} : 0)( true ? {
  name: "1yqd6d7",
  styles: "margin-top:5vh;text-transform:uppercase;font-weight:bold;font-size:3rem;color:white;font-family:var(--font-family);text-align:center;span{font-size:3rem;}@media screen and (max-width: 768px){margin-top:10vh;font-size:2rem;span{font-size:2rem;}}"
} : 0);
// EXTERNAL MODULE: ./shared/components/slider-collection-property/index.tsx
var slider_collection_property = __webpack_require__(2098);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/featured-property.tsx



function featured_property_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function FeaturedProperty() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.outstandingProperties");
  var featuredTitle = translation("title") || "";

  var _featuredTitle$split = featuredTitle.split(" "),
      _featuredTitle$split2 = (0,toArray/* default */.Z)(_featuredTitle$split),
      title = _featuredTitle$split2[0],
      rest = _featuredTitle$split2.slice(1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerFeaturedProperty, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    mb: 4
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(WsSectionTitleWithThinTitle_copy/* default */.Z, {
    title: rest.join(" "),
    subtitle: title,
    color: "white"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(slider_collection_property/* default */.Z, null), (0,emotion_react_browser_esm/* jsx */.tZ)(featured_property_CollectionButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_properties */.K.es.collection_properties,
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translation("seeMore")))));
}

/* harmony default export */ var featured_property = (FeaturedProperty);

var featured_property_CollectionButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "ew278nt1"
} : 0)( true ? {
  name: "qe273j",
  styles: "width:100%;margin:auto;margin-top:50px;display:flex;justify-content:center"
} : 0);

var ContainerFeaturedProperty = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ew278nt0"
} : 0)( true ? {
  name: "17r46in",
  styles: "width:100%;height:100%;margin-top:150px;& h2{padding-bottom:10px;}@media screen and (max-width: 600px){margin-top:100px;}"
} : 0);
// EXTERNAL MODULE: ./node_modules/react-youtube/dist/YouTube.esm.js
var YouTube_esm = __webpack_require__(13913);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./shared/components-pages/collection/landing/info-video-section.tsx






function InfoVideoSection() {
  var opts = {
    width: "100%",
    height: "450px",
    frameBorder: 2,
    playerVars: {
      autoplay: 0,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      control: 0
    }
  };
  var translation = (0,next_intl_cjs_production_min.useTranslations)("collection.remaxCollection");

  var _useState = (0,react.useState)(true),
      hiddenIframe = _useState[0],
      IsHiddenFrame = _useState[1];

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    rowGap: 2,
    alignItems: "center",
    px: 2
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    md: 7,
    mb: 4,
    maxWidth: 450
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
    color: "white",
    textAlign: "center"
  }, translation("description")), (0,emotion_react_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
    color: "white",
    textAlign: "center"
  }, translation("team"))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    md: 5,
    sx: {
      width: {
        xs: "100%",
        md: "50%"
      },
      height: {
        xs: "300px"
      }
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(YouTube_esm/* default */.Z, {
    videoId: "Ta1P6nRn03Y",
    opts: opts,
    onEnd: function onEnd() {
      IsHiddenFrame(true);
    }
  })));
}

/* harmony default export */ var info_video_section = (InfoVideoSection);
// EXTERNAL MODULE: ./shared/components/head-meta/index.tsx
var head_meta = __webpack_require__(23385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./shared/models/const/keywords.const.ts
var keywords_const = __webpack_require__(6644);
// EXTERNAL MODULE: ./shared/components/layout/index.tsx + 40 modules
var layout = __webpack_require__(85393);
;// CONCATENATED MODULE: ./pages/collection/index.tsx


function collection_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var Collection = function Collection(props) {
  var router = (0,next_router.useRouter)();
  var metaData = {
    title: "collection",
    keyWords: keywords_const/* CKeyWordsPages.homeCollections */.k.homeCollections,
    description: "collections",
    url: router.asPath,
    picture: "/images/image-optimize/remax-collection-cover_meta.jpg"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(layout/* default */.Z, {
    showFooter: true,
    backgroundColorFooter: "var(--color-brand-cream-primary)"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(head_meta/* default */.Z, metaData), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    style: {
      backgroundColor: "var(--color-brand-cream-primary)"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(cover_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentCurve, null, (0,emotion_react_browser_esm/* jsx */.tZ)(info_video_section, null), (0,emotion_react_browser_esm/* jsx */.tZ)(collection_ContainerFeaturedProperty, null, (0,emotion_react_browser_esm/* jsx */.tZ)(featured_property, null))), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerAgents, null, (0,emotion_react_browser_esm/* jsx */.tZ)(agents_collections, null))));
};

var __N_SSG = true;
/* harmony default export */ var collection = (Collection);

var collection_ContainerFeaturedProperty = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eknwuxn2"
} : 0)( true ? {
  name: "h34vad",
  styles: "margin:auto;width:100%;padding-bottom:80px"
} : 0);

var ContainerAgents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eknwuxn1"
} : 0)( true ? {
  name: "h34vad",
  styles: "margin:auto;width:100%;padding-bottom:80px"
} : 0);

var ContentCurve = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eknwuxn0"
} : 0)( true ? {
  name: "sbzvlz",
  styles: "width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;padding-top:100px;background:var(--color-brand-blue-collection-main);border-radius:0px 0px 0px 200px;@media screen and (max-width: 600px){border-radius:0px;}"
} : 0);

/***/ }),

/***/ 71099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11496);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);


var _templateObject;




function WsSectionTitleWithThinTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      color = _ref.color,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.6rem" : _ref$fontSize;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center",
    spacing: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 700,
    color: color
  }, title)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 400,
    color: color
  }, subtitle)));
}

/* harmony default export */ __webpack_exports__["Z"] = (WsSectionTitleWithThinTitle);
var Title = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  font-size: 1.8rem;\n  @media screen and (max-width: 768px) {\n    font-size: 1.4rem;\n  }\n"])));

/***/ }),

/***/ 23385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72717);
/* harmony import */ var next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);






function HeadMeta(props) {
  var title = props.title,
      description = props.description,
      url = props.url,
      og_type = props.og_type,
      picture = props.picture,
      canonical = props.canonical,
      keyWords = props.keyWords;
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("title-pages");
  var MetaDescriptionT = (0,next_intl__WEBPACK_IMPORTED_MODULE_2__.useTranslations)("metaDescriptions");
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_dist_shared_lib_head__WEBPACK_IMPORTED_MODULE_0___default()), null, title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("title", null, titleT(title)), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: description
  }), keyWords && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: keyWords
  }), url && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: "".concat("https://remaxrd.com").concat(url)
  }), og_type && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: og_type
  }), title && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: title
  }), description && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: MetaDescriptionT(description)
  }), picture && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: "https://remaxrd.com" + picture
  }), (url || canonical) && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("".concat("https://remaxrd.com").concat(canonical !== null && canonical !== void 0 ? canonical : url)),
    key: "canonical"
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeadMeta);

/***/ }),

/***/ 6644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ CKeyWordsPages; }
/* harmony export */ });
var CKeyWordsPages = {
  project: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana",
  join: "conviértete en agente inmobiliario remax, únete a remax república dominicana, agente inmobiliario remax, agencia inmobiliaria, agente inmobiliario, agente Remax",
  page404: "pagina no encontrada",
  home: "inmueble, remax rd, remax república dominicana, alquilar una casa, comprar una casa, comercialización de inmuebles, proyectos en construcción, beneficios de comprar en planos, préstamos hipotecarios, préstamos hipotecarios en república dominicana, franquicia remax, Propiedades destacadas, propiedades de Remax RD, propiedades de remax república dominicana, agente inmobliario, agencia inmobiliaria, propiedades en República Dominicana, alquiler apartamento, bienes raices santo domingo, departamentos en alquiler santo domingo, proyectos de apartamentos en punta cana, alquilar casa, apartamentos en santo domingo este, apartamentos en bavaro, apartamento en venta punta cana, apartamentos en rd, apartamentos en alquiler santo domingo este, proyectos de apartamentos económicos en santo domingo, apartamentos en venta san isidro, apartamentos en venta republica dominicana, apartamentos en alquiler en santo domingo distrito nacional, apartamento en alquiler, casas en alquiler en república dominicana, proyectos de apartamentos en santo domingo distrito nacional, venta de propiedades en republica dominicana, casas rd, venta de casas en santo domingo, apartamento en el millon, alquiler de apartamentos en santo domingo distrito nacional, comprar apartamento en santo domingo, compra de apartamentos en santo domingo, apartamentos en La Romana",
  homeCollections: "Remax collection, propiedades de lujo, propiedades exclusivas, propiedades premium, propiedades collection",
  mortgageLoad: "préstamo hipotecario, Calculadora de prestamos, cuota de préstamos hipotecarios, formulario de prestamos",
  iWantToRent: "casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almacén en alquiler, villas en alquiler, alquiler de aparta estudio, proyectos exclusivos de remax república dominicana",
  iWantToBuy: "proyectos exclusivos, proyecto exclusivo en construcción, proyecto exclusivo construido, proyectos exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almacén en venta, proyectos exclusivos de remax república dominicana, compra inmobiliaria, adquir propiedad inmobiliaria, inversion inmobiliaria en república dominicana, inversión inmobiliaria"
};

/***/ }),

/***/ 69178:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection",
      function () {
        return __webpack_require__(75340);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3828,8584,8360,2203,6869,3405,3913,4003,1691,2098,7814,9774,2888,179], function() { return __webpack_exec__(69178); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);